import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

import { LoadingPage } from '../loading/loading.page.component';

@Component({
    selector: 'itpx-reactive-form',
    template: ''
})
export abstract class ReactiveFormComponent extends LoadingPage {

    protected form: FormGroup;

    // Inputs
    protected submitting = new BehaviorSubject<boolean>(false);
    protected formSubmit = new Subject<any>();

    // Outputs
    protected submitSuccess: Observable<any>;
    protected inProgress: Observable<boolean>;

    constructor() {
        super();
    }

    ngOnInit() {

        let isValid = this.form.statusChanges
            .map(status => status == 'VALID')
            .startWith(false);

        this.inProgress = Observable.combineLatest(isValid, this.submitting, (valid, submitting) => !valid || submitting)
            .cacheResult();

        this.submitSuccess = this.formSubmit
            .do(_ => this.submitting.next(true))
            .switchMap(data => this.getFormSubmitQuery(data)
                .take(1)
                .doOnEach(() => this.submitting.next(false))
                .neverError()
            );

        this.submitting
            .bindToLifecycle(this)
            .subscribe(val => val ? this.form.disable() : this.form.enable());
    }

    protected abstract getFormSubmitQuery(data: any): Observable<any>;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/reactive-form/reactive-form.component.ts